import { UnstakeWithdraw } from "@/features/treasury/treasury";

export default function TreasuryStakingUnstakePage() {
  return <UnstakeWithdraw />;
}
